export const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
export const googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
export const appleClientId = process.env.VUE_APP_APPLE_CLIENT_ID;
export const appleRedirectUri = process.env.VUE_APP_APPLE_REDIRECT_URI;
export const recaptchaSitekey = process.env.VUE_APP_RECAPTCHA_SITEKEY;
export const recaptchaVerifyFlag = process.env.VUE_APP_RECAPTCHA_VERIFY_FLAG === "true";
export const AppLauncherJsUri = process.env.VUE_APP_ZYXEL_NETWORKS_APP_LAUNCHER_JS_URI;
export const AppLauncherCssUri = process.env.VUE_APP_ZYXEL_NETWORKS_APP_LAUNCHER_CSS_URI;
export const passkeyRPId = process.env.VUE_APP_RP_ID;
export const isDevelopment = process.env.NODE_ENV === 'development';